import React from 'react';
import './Loading.scss';

const Loading = ({ fullScreen = false, small = false }) => {
  if (fullScreen) {
    return (
      <div className="loadingFullScreen">
        <div className="loadingBox">
          <div className="lds-ring"><div></div><div></div><div></div><div></div></div>
          <div className="loadingText">Cargando...</div>
        </div>
      </div>
    );
  }

  return (
    <div className={small ? 'loadingInline small' : 'loadingInline'}>
      <div className="lds-ring"><div></div><div></div><div></div><div></div></div>
    </div>
  );
};

export default Loading;
